module.exports = __webpack_public_path__ + "img/雪山3_1.2ae18655.jpg";